<template>
  <div class="PlatformProjectsView">
    <ShPageHeader title="Projekty"
                  description="Poniżej znajduje się lista wszystkich projektów klienta.<br>"
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'Projekty', path: '/projects' }
                  ]"
    />
    <ShPageLayout>
      <ProjectsList />
    </ShPageLayout>
  </div>
</template>

<script>
import store from '@/store';
import ProjectsList from '@/components/Projects/ProjectsList';

export default {
  name: 'PlatformClients',
  store,
  components: {
    ProjectsList,
  },

  beforeRouteLeave(to, from, next) {
    // this.$store.dispatch('client/projects/clearFilteringCriteria');
    next();
  },
};
</script>
